module.exports = __webpack_public_path__ + "3aaca52089b13d82b4c0af1914358075.png";